var pym = require("./lib/pym");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
var L = require('leaflet/dist/leaflet.js');
var pymChild;
var COLORS = require("./lib/helpers/colors.js");
var d3 = require("d3");



// Initialize the graphic.
var onWindowLoaded = function() {

  Promise.all([
    d3.json("./tennessee_outline.geojson"),
  ]).then(function(data) {
    render(data[0]);
    window.addEventListener("resize", function() { render(data[0]) });
    pym.then(child => {
      pymChild = child;
      child.sendHeight();
    });
  });
};

// Render the graphic(s). Called by pym with the container width.
var render = function(border) {
  // Render the chart!
  var container = "#map";
  var element = document.querySelector(container);
  var width = element.offsetWidth;
  renderMap({
    container,
    width,
    data: DATA,
    border: border
  });

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

// Render map.
var renderMap = function(config) {

  var data = config.data;

  // Clear existing graphic (for redraw)
  var containerElement = d3.select("#key");
  containerElement.html("");

  var labels = d3.map(data, function(d){return d.type;}).keys();
  var color = d3.scaleOrdinal()
    .domain(labels)
    .range([COLORS.gray1, COLORS.teal2, COLORS.gray2, COLORS.peach2, COLORS.blue2, COLORS.gray1]);

  var legend = containerElement
    .append("ul")
    .attr("class", "key")
    .selectAll("g")
    .data(color.domain())
    .enter()
    .append("li")
    .attr('class','key-item');

  legend.append("b").style("background-color", d => color(d));
  legend.append("label").text(d => d + " charter schools");

  // Basemap options
  var base = {
    'Esri_WorldGrayCanvas': L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}'),
    'Empty': L.tileLayer(''),
    'OpenStreetMap': L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'),
    'Wikimedia': L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png')
  }

  var zoomLevel = isMobile.matches ? 6 : 7;
  var baseSize = isMobile.matches ? 5 : 5;

  // Set up the map
  var map = L.map('map', {
    'layers':[base.OpenStreetMap.setOpacity(0.5)],
    attributionControl:false,
  });
  map.setView([35.70232754, -86.63586323], zoomLevel);

  var borderLayer = L.geoJSON(config.border, {
    color: COLORS.gray2,
    fillOpacity: 0,
    weight: 1
  }).addTo(map);

  map.fitBounds(borderLayer.getBounds(), {padding: [0,0]});

  // Add circle markers
  for (var i = 0; i < data.length; i++) {
			circle = new L.circleMarker([data[i].latitude,data[i].longitude], {
        fillColor: data[i].type == "" ? "#fff" : color(data[i].type),
        fillOpacity: 1,
        // radius: data[i].count*2,
        radius: data[i].type == "Existing" ? baseSize*2 : baseSize,
        stroke: true,
        // opacity: data[i].type == "Existing" ? 0.45 : 1,
        color: data[i].type == "" ? COLORS.gray2 : COLORS.gray1,
        weight: 1
      })
				.bindPopup(data[i].count == 1 ? '<strong>' + data[i].name + '</strong></br>' + data[i].count + ' ' + data[i].type.toLowerCase() + ' school' :
                                        '<strong>' + data[i].name + '</strong></br>' + data[i].count + ' ' + data[i].type.toLowerCase() + ' schools')
        .on('mouseover',function(d) {
          this.openPopup();
        })
        .addTo(map);
		}


}



/*
 * Initially load the graphic
 * (NB: Use window.load to ensure all images have loaded)
 */
window.onload = onWindowLoaded;
